import React from "react";
import { cn } from "@/lib/utils";

// Loads /assets/site/<name>.jpg. Until you upload that file, it shows a
// representative stock photo so the layout looks complete. Drop the real
// image at the path and it replaces the placeholder automatically.
export default function SiteImage({ name, fallback, alt = "", ratio = "16/9", className }) {
  return (
    <div
      className={cn("relative overflow-hidden rounded-3xl border border-border bg-parchment shadow-sm", className)}
      style={{ aspectRatio: ratio }}
      data-testid={`site-image-${name}`}
    >
      <img
        src={`/assets/site/${name}.jpg`}
        alt={alt}
        loading="lazy"
        onError={(e) => {
          if (fallback && e.currentTarget.dataset.fb !== "1") {
            e.currentTarget.dataset.fb = "1";
            e.currentTarget.src = fallback;
          }
        }}
        className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
      />
    </div>
  );
}
